import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 召開 ")
const _hoisted_2 = { class: "pr-5 pl-5 pb-5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loading records, please wait... ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 編輯 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 刪除 ")

export function render(_ctx: any,_cache: any) {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_Create = _resolveComponent("Create")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_Column = _resolveComponent("Column")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_EyeSharp = _resolveComponent("EyeSharp")!
  const _component_MdCheckmark = _resolveComponent("MdCheckmark")!
  const _component_Pencil = _resolveComponent("Pencil")!
  const _component_Trash = _resolveComponent("Trash")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_HosterModal = _resolveComponent("HosterModal")!
  const _component_HosterResponseModal = _resolveComponent("HosterResponseModal")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_space, {
      justify: "space-between",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_form, {
              "label-placement": "left",
              model: _ctx.hosterTimeRang,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  label: "會議創建日",
                  "label-style": { 'color': 'true' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_date_picker, {
                      value: _ctx.hosterTimeRang.data,
                      "onUpdate:value": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hosterTimeRang.data) = $event)),
                        _ctx.updateDatePicker
                      ],
                      type: "daterange",
                      size: "large",
                      actions: null,
                      "close-on-select": true,
                      separator: "To",
                      format: _ctx.format
                    }, null, 8, ["value", "onUpdate:value", "format"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_n_button, {
              type: "success",
              size: "large",
              "icon-placement": "right",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEdit('I')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Create)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DataTable, {
        value: _ctx.data,
        ref: "data_dt",
        dataKey: "EventHeaderId",
        loading: _ctx.loading,
        paginator: true,
        rows: 10,
        rowHover: true,
        resizableColumns: true,
        columnResizeMode: "fit",
        class: "p-datatable-sm",
        stripedRows: ""
      }, {
        loading: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "ID",
            sortable: true,
            style: {"width":"5rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.index+1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "Title",
            header: "標題",
            sortable: true,
            style: {"width":"25rem"}
          }),
          _createVNode(_component_Column, {
            field: "StartUTCDateTime",
            header: "決議日期",
            style: {"width":"10rem"},
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.Status == _ctx.ParamEventStatus.Cancel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (slotProps.data.IsResolution == _ctx.ParamIsResolution.NotYet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString("日期未決議")))
                  : (_ctx.dayjs( slotProps.data.StartUTCDateTime).isAfter(_ctx.dayjs( '0001-01-01T00:00:00')))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.dayjs( slotProps.data.StartUTCDateTime).format(" YYYY/MM/DD (ddd)")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "Location",
            header: "地點",
            style: {"width":"10rem"},
            sortable: true
          }),
          _createVNode(_component_Column, {
            field: "Status",
            header: "狀態",
            style: {"width":"8rem"},
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.Status == _ctx.ParamEventStatus.Close)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (slotProps.data.Status == _ctx.ParamEventStatus.Open)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (slotProps.data.Status == _ctx.ParamEventStatus.Cancel)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 2,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "SubmitDueDateUTCDateTime",
            style: {"width":"10rem"},
            header: "回覆截止日",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.dayjs( slotProps.data.SubmitDueDateUTCDateTime).format("YYYY/MM/DD (ddd)")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "CreateUTCDateTimeOnDbServer",
            style: {"width":"10rem"},
            header: "會議創建日",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.dayjs( slotProps.data.CreateUTCDateTimeOnDbServer).format("YYYY/MM/DD (ddd)")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "編輯/檢視" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_n_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    type:  slotProps.data.Status == _ctx.ParamEventStatus.Open
            ? 'success' : 
            slotProps.data.IsResolution==_ctx.ParamIsResolution.NotYet && slotProps.data.Status==_ctx.ParamEventStatus.Close 
            ? 'error' : 'info' ,
                    secondary: "",
                    onClick: ($event: any) => (_ctx.onDetail(slotProps.data))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          ((slotProps.data.Status == _ctx.ParamEventStatus.Close &&
                  slotProps.data.IsResolution == _ctx.ParamIsResolution.Done) ||
                  (
                    slotProps.data.Status == _ctx.ParamEventStatus.Cancel
                  )
                  )
                            ? (_openBlock(), _createBlock(_component_EyeSharp, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_MdCheckmark, { key: 1 }))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      ((slotProps.data.Status == _ctx.ParamEventStatus.Close &&
              slotProps.data.IsResolution == _ctx.ParamIsResolution.Done) ||
              (
                slotProps.data.Status == _ctx.ParamEventStatus.Cancel
              )
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 查看會議 "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, " 決議時間 "))
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"]),
                  (slotProps.data.Status == _ctx.ParamEventStatus.Open)
                    ? (_openBlock(), _createBlock(_component_n_button, {
                        key: 0,
                        type: "primary",
                        ghost: "",
                        onClick: ($event: any) => (_ctx.onEdit('U',slotProps.data))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Pencil)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!((slotProps.data.Status == _ctx.ParamEventStatus.Close &&
              slotProps.data.IsResolution == _ctx.ParamIsResolution.Done) ||
              (
                slotProps.data.Status == _ctx.ParamEventStatus.Cancel
              ))
              )
                    ? (_openBlock(), _createBlock(_component_n_button, {
                        key: 1,
                        type: "error",
                        secondary: "",
                        onClick: ($event: any) => (_ctx.onDelete(slotProps.data))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Trash)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _createVNode(_component_HosterModal, {
      showModal: _ctx.showModal,
      actionModal: _ctx.actionModal,
      onShowModalClose: _ctx.showModalClose
    }, null, 8, ["showModal", "actionModal", "onShowModalClose"]),
    _createVNode(_component_HosterResponseModal, {
      showModal: _ctx.showResponseModal,
      event: _ctx.event,
      onShowModalClose: _ctx.showResponseModalClose
    }, null, 8, ["showModal", "event", "onShowModalClose"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showConfirmModal) = $event)),
      "mask-closable": false,
      preset: "dialog",
      title: "小提醒視窗",
      content: _ctx.ConfirmMessage,
      "positive-text": "Yes",
      onPositiveClick: _ctx.onPositive,
      onNegativeClick: _ctx.onNegative,
      "negative-text": "No"
    }, null, 8, ["show", "content", "onPositiveClick", "onNegativeClick"])
  ], 64))
}